import { Popover } from "@mantine/core";
import moment from "moment-jalaali";
import React, { useMemo } from "react";
import { CalendarEvent, getWeekDays, MonthViewProps } from "./types";
import { EventItem } from "./EventItem";
import { getPartnerDayEvents } from "./helper/helper";

const VISIBLE_EVENTS = 3;

const MonthView = ({ currentDate, partners, onEventClick, setSelectedEvent, isPersian, view, matches, onOpenDay }: MonthViewProps) => {
  const days = useMemo(() => {
    const start = isPersian ? currentDate?.clone().startOf("jMonth") : currentDate?.clone().startOf("month");
    const end = (isPersian ? currentDate?.clone().endOf("jMonth") : currentDate?.clone().endOf("month"))?.endOf("week");
    const cursor = start?.clone().startOf("week");
    const result: moment.Moment[] = [];
    while (cursor && end && cursor.isSameOrBefore(end)) { result.push(cursor.clone()); cursor.add(1, "day"); }
    return result;
  }, [currentDate, isPersian]);
  const eventsByDate = useMemo(() => {
    const result = new Map<string, CalendarEvent[]>();
    for (const partner of partners || []) {
      const dates = new Set((partner.appointmentCalendar || []).map(day => moment(day.appointmentDate).format("YYYY-MM-DD")));
      for (const date of dates) {
        const events = getPartnerDayEvents(partner.appointmentCalendar, moment(date, "YYYY-MM-DD"), partner);
        result.set(date, [...(result.get(date) || []), ...events]);
      }
    }
    for (const events of result.values()) events.sort((a, b) => String(a.startTime || "").localeCompare(String(b.startTime || "")));
    return result;
  }, [partners]);
  const todayKey = moment().format("YYYY-MM-DD");
  const visible = matches ? 2 : VISIBLE_EVENTS;
  const renderEvent = (event: CalendarEvent, index: number) => (
    <EventItem key={String(event.merchantUserId) + "-" + String(event.id) + "-" + index} event={event} onEventClick={onEventClick} setSelectedEvent={setSelectedEvent} view={view} />
  );
  return (
    <div className="calendar-month-viewport calendar-scroll" tabIndex={0} role="region" aria-label="جدول ماهانه؛ قابل پیمایش افقی و عمودی">
      <div className="calendar-month-grid" style={{ "--month-weeks": days.length / 7 } as React.CSSProperties}>
        {getWeekDays(isPersian).map(day => <div key={day} className="calendar-month-weekday">{day}</div>)}
        {days.map(day => {
          const key = day.format("YYYY-MM-DD");
          const isCurrentMonth = isPersian ? day.jMonth() === currentDate?.jMonth() : day.month() === currentDate?.month();
          const events = isCurrentMonth ? eventsByDate.get(key) || [] : [];
          const hidden = events.length > visible ? events.length - (visible - 1) : 0;
          const label = isPersian ? day.format("dddd jD jMMMM") : day.format("dddd D MMMM");
          return (
            <div key={key} className="calendar-month-day" data-outside={!isCurrentMonth || undefined} data-today={key === todayKey || undefined}>
              <button type="button" className="calendar-month-number" onClick={() => onOpenDay?.(day.clone())} aria-label={`نمای روزانهٔ ${label}`} disabled={!onOpenDay}>
                {isPersian ? day.jDate() : day.date()}
              </button>
              <div className="calendar-month-events">
                {(hidden ? events.slice(0, visible - 1) : events).map(renderEvent)}
                {hidden > 0 && (
                  <Popover position="bottom" width={260} shadow="md" withinPortal zIndex={400}>
                    <Popover.Target>
                      <button type="button" className="calendar-month-more">+{hidden} نوبت دیگر</button>
                    </Popover.Target>
                    <Popover.Dropdown className="calendar-month-popover" dir="rtl">
                      <div className="calendar-month-popover-title">{label}<span>{events.length} نوبت</span></div>
                      <div className="calendar-month-popover-list">{events.map(renderEvent)}</div>
                    </Popover.Dropdown>
                  </Popover>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
const MemoMonthView = React.memo(MonthView);
export default MemoMonthView;
